import * as React from 'react';
import { Slider } from 'wix-style-react';
import type { SliderProps as WSRSliderProps } from 'wix-style-react';
import type { IRangeSliderProps } from '../../RangeSlider.props';

type IContinuousSliderProps = Pick<IRangeSliderProps, 'min' | 'max'> &
  Pick<
    WSRSliderProps,
    | 'id'
    | 'step'
    | 'value'
    | 'rtl'
    | 'className'
    | 'dataHook'
    | 'disabled'
    | 'pushable'
    | 'ariaLabelForHandle'
    | 'onChange'
    | 'onFocus'
    | 'onBlur'
    | 'ariaLabelledByForHandle'
    | 'rangeRef'
  >;

const ContinuousSlider: React.FC<IContinuousSliderProps> = props => {
  const {
    className,
    dataHook,
    id,
    rtl,
    min,
    max,
    value,
    disabled,
    pushable,
    ariaLabelForHandle,
    onChange,
    onFocus,
    onBlur,
    ariaLabelledByForHandle,
    rangeRef,
  } = props;

  return (
    <Slider
      className={className}
      dataHook={dataHook}
      id={id}
      rtl={rtl}
      min={min}
      max={max}
      step={0.1}
      value={value}
      displayMarks={false}
      displayTooltip={true}
      allowCross={false}
      onChange={onChange}
      disabled={disabled}
      pushable={pushable}
      ariaLabelForHandle={ariaLabelForHandle}
      onFocus={onFocus}
      onBlur={onBlur}
      ariaLabelledByForHandle={ariaLabelledByForHandle}
      rangeRef={rangeRef}
    />
  );
};

export default ContinuousSlider;
